<template>
  <div class="left-top-left-list">
    <titleInternal titleName="点位及人力部署"></titleInternal>
    <baseDisplay :baseDataList="baseDataList"></baseDisplay>
    <div class="flex-just" style="margin-top: 35px">
      <div class="point-bs">
        <div class="title">点位部署</div>
        <div style="width: 355px; height: 281px; margin-top: 12px">
          <wgEchart v-if="isShowPoint" :options="optionsList" id="leftTopleftOne"></wgEchart>
        </div>
      </div>
      <div class="point-bs">
        <humanResourceDeployment></humanResourceDeployment>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreen/components/title-internal.vue";
import baseDisplay from "@/pages/patrolScreen/components/base-display.vue";
import humanResourceDeployment from "@/pages/patrolScreen/components/left/humanResourceDeployment.vue";
import { getResourcePointAndPerson, getResourcePoint } from "@/api/daping.js";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
    baseDisplay,
    humanResourceDeployment,
  },
  data() {
    return {
      baseDataList: [
        {
          img: require("@/assets/daping/shequ.png"),
          name: "社区/个",
          num: 0,
          key: "communityCount"
        },
        {
          img: require("@/assets/daping/dianwei.png"),
          name: "点位/个",
          num: 0,
          key: "pointCount"
        },
        {
          img: require("@/assets/daping/znbm.png"),
          name: "职能部门/个",
          num: 0,
          key: "functionDeptCount"
        },
        {
          img: require("@/assets/daping/zbry.png"),
          name: "系统用户/名",
          num: 0,
          key: "permanentStaffCount"
        },
      ],
      optionsList: {},
      tabPosition: "top",
      isShowPoint: false
    };
  },
  mounted() {
    this.getResourcePointAndPerson();
    this.getResourcePoint();
  },
  methods: {
    optionsListData(dataList) {
      var color = [
        "#033362",
        "#1e2762",
        "#033e60",
        "#0b2155",
        "#272f40",
        "#0c3a43",
        "#292444",
        "#032d59",
        "#0b2a5c",
        "#033b5e",
      ]
      let data = []
      dataList.forEach((item, index) => {
        data.push({
          value: item.pointCount,
          name: item.pointName,
          itemStyle: {
          color: color[index % 10],
        },
        })
      })
      let option = {
        legend: {
          show: false,
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "treemap",
            width: "100%",
            height: "100%",
            breadcrumb: {
              show: false,
            },

            label: {
              normal: {
                show: true,
                textStyle: {
                  color: "rgba(255,255,255,0.7)",
                  fontSize: 16,
                },
                formatter: function (params) {
                  return params.data.name + "\n" + params.data.value;
                },
              },
            },
            itemStyle: {
              normal: {
                show: true,
                borderColor: "#fff",
              },
              emphasis: {
                label: {
                  show: true,
                },
              },
            },
            roam: false,
            data: data,
          },
        ],
      };
      this.optionsList = option;
      this.isShowPoint = true;
    },
    inputChange() {},
    // 获取人力及点位部署
    async getResourcePointAndPerson() {
      const res = await getResourcePointAndPerson();
      if (res.data.code == 200) {
        this.baseDataList.forEach((item) => {
          item.num = res.data.data[item.key]
        });
      }
    },
    // 点位部署
    async getResourcePoint() {
      const res = await getResourcePoint();
      if (res.data.code == 200) {
        let dataList = res.data.data;
        this.optionsListData(dataList);
      }
    },
  },
};
</script>
<style scoped lang="less">
.left-top-left-list {
  width: 100%;
  height: 615px;
}
.flex-just {
  display: flex;
  justify-content: space-between;
}
.point-bs {
  width: 355px;
  height: 331px;
  background: linear-gradient(0deg, rgba(0, 163, 255, 0) 0%, rgba(0, 163, 255, 0.1) 100%);
  border-radius: 4px;
  position: relative;
  .title {
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 18px;
    color: #f3f8ff;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
    color: transparent;
    /* 使用背景渐变填充文字 */
    -webkit-background-clip: text;
    background-clip: text;
    text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
    margin: 14px 0 0 12px;
  }
}

.special-radio {
  height: 28px;
  position: absolute;
  top: 12px;
  right: 12px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/left/left-top-left.vue